
import React, { FC,  useCallback,  useMemo, useState } from 'react';
import {  CustomButtonGroup,  DashboardLoader, useAppDispatch } from '../../globalUtils/globalExports';
import { checkValidNoWhitespace, createBreadCrumbProps, keyPressValidationNoWhitespace,  } from '../../globalUtils/globalHooks';


import CustomForm, { ICustomFormProps, IFormContentProp } from '../../globalUtils/CustomForm/CustomForm';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { cloneDeep } from 'lodash';
import { generateUsbCertificates } from '../../rmsReduxStore/reduxExports';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';


interface EmployeeCertificateData{
   name:string ;
   countryCode:string;
   mobileNumber:string;
   employeeId:string;
   usbDeviceIdentifier: string;
   expiryDateTime: string;
}



const CreateUsbCertificate: FC= () => {
    
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const initialEmployeeCertificateData: EmployeeCertificateData = {
        name:'' ,
        countryCode:'',
        mobileNumber:'',
        employeeId:'',
        usbDeviceIdentifier: '',
        expiryDateTime: new Date().toISOString(),
      }
   
    const [employeeCertificateFormData, setEmployeeCertificateFormData] = useState<EmployeeCertificateData>(initialEmployeeCertificateData);
    const [ mobileError,setMobileError]=useState('');
    const [showLoader, setShowLoader] = useState(false);


    const handleFormDataChange = useCallback((val, formKey, mobileDialCode?) => {
      const formData = cloneDeep(employeeCertificateFormData);
      formData[formKey] = val;
      if (formKey === 'mobileNumber') formData['countryCode'] = mobileDialCode
      setEmployeeCertificateFormData(formData);
    }, [employeeCertificateFormData]);

      const handleSubmit = async ()=>{
        const reqBody={
          name:employeeCertificateFormData?.name,
          countryCode:employeeCertificateFormData.countryCode,
          mobileNumber:employeeCertificateFormData?.mobileNumber,
          employeeId:employeeCertificateFormData?.employeeId,
          usbDeviceIdentifier: employeeCertificateFormData?.usbDeviceIdentifier,
          expiryDateTime: employeeCertificateFormData?.expiryDateTime
        }

         const  response = await dispatch(generateUsbCertificates(reqBody))
        if ((response?.status === 200 || response?.status === 202) && response?.data?.message === 'Success') {
          setShowLoader(false)
          toast.success('Certificates Generated Successfully.');
          window.open(response?.data?.downloadUrl, '_blank');
          navigate('/usb-certificates')
        } else {
          setShowLoader(false)
            toast.error(response?.data?.message)
        }
      }
  const formArray: IFormContentProp[] = [
    {
      rowCountClassName: 'grid-3',
      formObject: [
        {
          formLabel: 'Employee Name',
          isRequired: true,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder:'',
            handleInputChange: (event): void => {
                handleFormDataChange(event.target.value,'name')
            },
            inputValue: employeeCertificateFormData?.name,
            inputType: 'string',
            inputFieldId: 'employee_name',
            isRequired: true,
            isDisabled:false,
            autoFocus: true,
          },
          textAreaProps: null,
        },
        {
            formLabel: 'Employee ID',
            isRequired: true,
            objectType: 'input',
            selectDropdownProps: null,
            inputProps: {
              inputPlaceHolder:'',
              handleInputChange: (event): void => {
                handleFormDataChange(event.target.value,'employeeId')
              },
              inputValue: employeeCertificateFormData?.employeeId,
              inputType: 'string',
              inputFieldId: 'employee_id',
              isRequired: true,
              isDisabled:false,
              autoFocus: true,
            },
            textAreaProps: null,
          },
          {
            formLabel: 'Mobile Number',
            isRequired: true,
            objectType: 'mobile-number',
            selectDropdownProps: null,
            onMobileNumberChange: (value, countryCode, dialCode): void => {
              const isValidMobileNumber = isValidPhoneNumber(`+${value}`, countryCode);
              if (!isValidMobileNumber && value?.slice(dialCode?.length)?.length > 0) {
                setMobileError('Please enter a valid mobile number.')
              } else {
                setMobileError('')
              }
              handleFormDataChange(value, 'mobileNumber', dialCode);
            },
            inputProps: {
              className: 'user__form-mobile-input',
              errorMessage: mobileError,
              inputValue:  employeeCertificateFormData?.mobileNumber,
              inputFieldId: 'add_employee_mobile_number',
              isRequired: true,
              isDisabled: false
            },
            textAreaProps: null,
          },
      ],
    },
    {
      rowCountClassName: 'grid-3',
      formObject: [
        {
            formLabel: 'USB Device Identifier',
            isRequired: true,
            objectType: 'input',
            selectDropdownProps: null,
            inputProps: {
              inputPlaceHolder:'',
              handleInputChange: (event): void => {
                handleFormDataChange(checkValidNoWhitespace(event.target.value),'usbDeviceIdentifier')
              },
              handleKeyPress: keyPressValidationNoWhitespace,
              inputValue: employeeCertificateFormData?.usbDeviceIdentifier,
              inputType: 'string',
              inputFieldId: 'usb_device_identifier',
              isRequired: true,
              isDisabled:false,
              autoFocus: true,
            },
            textAreaProps: null,
          },
          {
            formLabel: 'Expiry Date & Time',
            isRequired: true,
            objectType: 'input',
            selectDropdownProps: null,
            inputProps: {
              inputPlaceHolder:'',
              handleInputChange: (event): void => {
                const value = new Date(event.target.value);
                if(value.getTime() < Date.now()) {
                  toast.error('The expiry date and time must be in the future.');
                  return
                }
                handleFormDataChange(value.toISOString(),'expiryDateTime')
              },
              inputValue: dayjs(employeeCertificateFormData?.expiryDateTime).format('YYYY-MM-DDTHH:mm'),
              inputType: 'datetime-local',
              inputFieldId: 'expiry_date_time',
              isRequired: true,
              isDisabled:false,
              autoFocus: true,
              restrictPastDate: true
            },
            textAreaProps: null,
          },
      ]
    }
  ];
 
  const isSubmitBtnDisabled=()=>{
    if(employeeCertificateFormData?.name && employeeCertificateFormData?.employeeId && employeeCertificateFormData?.mobileNumber && isValidPhoneNumber(`+${employeeCertificateFormData?.mobileNumber}`) && employeeCertificateFormData?.usbDeviceIdentifier && employeeCertificateFormData?.expiryDateTime){
      return false;
    }
    return true
  }
  const btnsList = useMemo(() => {
    return [
      {
        buttonText: 'Generate',
        buttonId: 'add',
        btnClassName:'primary__btn',
        handleClick: (): void => {
                    handleSubmit();
        }, 
        isDisabled: isSubmitBtnDisabled(),
        buttonVariant: 'filled',
      },
      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
                setEmployeeCertificateFormData(initialEmployeeCertificateData);
                //Fix: cancel button not working
                  navigate('/usb-certificates')
        },
        isDisabled: false,
        buttonVariant: 'outlined',
      },
    ];
  }, [handleSubmit]);

  const breadCrumbs = createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'usbCertificates',
        },
        {
          objectType: 'text',
          id: 'text',
          text: 'Generate Certificate'
        }
      ]
  })
  const customFormProps: ICustomFormProps = useMemo(() => {
    return {
      formContainerClassName: 'add__parameter__wrap',
      breadCrumbprops: {
        containerId: 'add-parameter-breadcrumb',
        containerClassName: 'add-parameter-breadcrumb',
        breadCrumbs: breadCrumbs
      },
      headerPropTypes: {
        header: 'Generate Certificate',
        headerClassName: 'add__parameter__wrap-header-text',
      },
      formArray: formArray
    };
  }, [formArray, btnsList,employeeCertificateFormData])
    return (

     <>
      <DashboardLoader showLoader={showLoader} />
      <div className='charger__form__wrap'>
        <div className='charger__form__wrap-content'>
          <CustomForm {...customFormProps} />
        </div>
        <div className='charger__form__wrap-footer'>
          <CustomButtonGroup
            buttonsList={btnsList}
            buttonGroupClassName='button__group__footer' />
        </div>
      </div>
    </>
  );
};
export default CreateUsbCertificate;

